const sendMessageFromPlatformEvent = () => {
    const event = new Event("onAuthenticationSuccess");
    window.dispatchEvent(event);
};
export { sendMessageFromPlatformEvent };
